export const DELETE_CATEGORY_MODAL_TITLE = 'Are you sure you want to delete this category?';
export const DELETE_CATEGORY_MODAL_DESCRIPTION =
  'The items in this category will be deleted as well.';
export const DELETE_CONFIRMATION_BUTTON_TEXT = 'Delete';
